export default {
    computed: {
        getInterceptStatus () {
            return [
                {
                    label: this.$t('erp.b2c.intercepting_in_progress',{defaultValue:'拦截中'}),
                    value: 0,
                    theme: "primary"
                },
                {
                    label: this.$t('erp.b2c.intercepted_successfully',{defaultValue:'拦截成功'}),
                    value: 1,
                    theme: "success"
                },
                {
                    label: this.$t('erp.b2c.intercept_failed',{defaultValue:'拦截失败'}),
                    value: 2,
                    theme: "error"
                },
                {
                    label: this.$t('erp.b2c.partial_interception',{defaultValue:'部分拦截'}),
                    value: 3,
                    theme: "warning"
                },
                {
                    label: this.$t('erp.product.none',{defaultValue:'无'}),
                    value: 4,
                    theme: ""
                }
            ]
        },
        // 配货单状态 0 已创建 1已推送 2已发货 3已取消 4 取消中 5草稿
        getDeliveryStatus () {
            return [
                {
                    label: this.$t('fbb.costmanage.created',{defaultValue:'已创建'}),
                    value: 0
                },
                {
                    label: this.$t("erp.distribution.pushed", {defaultValue: "已推送"}),
                    value: 1
                },
                {
                    label: this.$t("erp.b2c.orderstatus_shipped", {defaultValue: "已发货"}),
                    value: 2
                },
                {
                    label: this.$t("global.common.canceled", {defaultValue: "已取消"}),
                    value: 3
                },
                {
                    label: this.$t("erp.b2c.cancelling_progress", {defaultValue: "取消中"}),
                    value: 4
                },
                {
                    label: this.$t("fbb.headlogistics.draft", { defaultValue: "草稿"}),
                    value: 5
                }
            ]
        }
    }
}